import React from 'react';
import {Button, Dialog, DialogActions, DialogContent, Typography,  DialogTitle,Grid, IconButton,} from '@material-ui/core';
import {CloseIcon, CloseIconColor} from '../../../components/Icons';
import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';
import {primaryGray} from 'src/components/colors';
import {environment} from 'src/environments/environment';
import axios from 'axios';
import useStyles from "src/app/maintenance/assets/styles";

export function DeleteProductType(props) {
  const classes = useStyles();
  const {productName, id} = props.productType;
  const device = props.device;

  const handleDelete = async () => {
    try {
      if (props.type === 'product') {
        await props.removeProductTypeById(id);
      } else if (props.type === 'device') {
        await props.removeDeviceFromProductType(device.id);
      }
      props.onClose();
    } catch (error) {
      console.error("Error during deletion:", error);
    }
  };
  const closePopup = () => {
    props.onClose();
  };

  return (
    <Dialog
      open={props.open}
      maxWidth="lg" classes={{paper: classes.deletePopup}}>
      <Grid container className={classes.deleteHeader}>
        <Grid item xs={10} md={10} >
          <DialogTitle className={classes.title}>{'CONFIRMATION'} </DialogTitle>
        </Grid>
        <Grid item xs={2} md={2} style={{textAlign: "right"}}>
          <IconButton onClick={closePopup} style={{paddingTop: "20px"}}>
            <CloseIconColor/>
      </IconButton>
        </Grid>
      </Grid>
      <DialogContent className={classes.deleteContent}>
        <Grid container>
          <Grid style={{ margin: "0" }}>
      <Typography className={classes.label}>
          {props.type === 'product' ? 
          `Do you want to delete the product type ${productName}?`
          : `Do you want to remove this device ${device.name} from the product type ${productName}?`}
        </Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <div  className={classes.DeletePopupFooter}>
        <Button
        variant='contained' 
        className={classes.popupCancel} 
        onClick={closePopup}>
          Cancel
        </Button>
        <Button
          variant="contained"
          className={classes.popupDelete}
          style={{marginRight: "21px"}}
          onClick={handleDelete}
        >
          {props.type === 'product' ? 'Delete' : 'Remove'}
        </Button>
      </div>
    </Dialog>
  );
}



export function ToggleConfig(props) {
  const classes = useStyles();
  const {productName, id} = props.productType;

  const handleToggle = async () => {
    try {
      
      props.onClose();
    } catch (error) {
      console.error("Error during deletion:", error);
    }
  };
  const closePopup = () => {
    props.onClose();
  };

  return (
    <Dialog
      open={props.open}
      maxWidth="lg" classes={{paper: classes.popUpContent}}
      BackdropProps={{
          style: {
            backgroundColor: "cubic-bezier(0.4, 0, 0.1, 1)",
            opacity: "0.4",
          },
        }}
        PaperProps={{
          style: {
            boxShadow: "inherit",
          },
        }}>
      <Grid container className={classes.popupHeading}>
        <Grid item xs={10} md={10} >
          <DialogTitle className={classes.title}>{'CONFIRMATION'} </DialogTitle>
        </Grid>
        <Grid item xs={2} md={2} style={{textAlign: "right"}}>
          <IconButton onClick={closePopup} style={{paddingTop: "20px"}}>
            <CloseIconColor/>
      </IconButton>
        </Grid>
      </Grid>
      <DialogContent className={classes.deleteContent}>
        <Grid container>
          <Grid style={{ margin: "0" }}>
      <Typography className={classes.label}>
          {props.type === 'ota' ? 
          `Do you want to ${props.enable?"enable":"disable"} OTA configuration of product type ${productName}??`
          : `Do you want to ${props.enable?"enable":"disable"}  remote configuration of product type ${productName}?`}
        </Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <div  className={classes.DeletePopupFooter}>
        <Button
        variant='contained' 
        className={classes.buttonBackLight} 
        onClick={closePopup}>
          No
        </Button>
        <Button
          variant="contained"
          className={classes.buttonOK}
          style={{marginRight: "21px"}}
          onClick={props.onSaveClick}
        >
         Yes
        </Button>
      </div>
    </Dialog>
  );
}
